import { render, staticRenderFns } from "./invoiceExamine.vue?vue&type=template&id=e87f80ca&scoped=true&"
import script from "./invoiceExamine.vue?vue&type=script&lang=js&"
export * from "./invoiceExamine.vue?vue&type=script&lang=js&"
import style0 from "./invoiceExamine.vue?vue&type=style&index=0&id=e87f80ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f80ca",
  null
  
)

export default component.exports